// Tema Shopify - JavaScript principal

class Theme {
  constructor() {
    window.theme = this;
    this.init();
  }

  init() {
    this.initHeader();
    this.initProductCards();
    this.initCartDrawer();
    this.initCartOnlyDrawer();
    this.initCartUpsell();
    this.initCartShipping();
    this.initMainCartSteppers();
    this.initMainProduct();
    this.initProductGallery();
    this.refreshCartUI();
    this.initSearch();
    this.initDhSearchBar();
    this.initDhMobileMenu();
    this.initRelatedProductRecommendations();
    this.initMobileMenu();
    this.initCollectionPriceRange();
    this.initCollectionInfiniteScroll();
  }

  // Inicializar funcionalidades do cabeçalho
  initHeader() {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    // Cabeçalho fixo
    let lastScrollTop = 0;
    window.addEventListener('scroll', () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollTop > lastScrollTop && scrollTop > 100) {
        header.classList.add('header--hidden');
      } else {
        header.classList.remove('header--hidden');
      }
      
      lastScrollTop = scrollTop;
    });
  }

  // Inicializar cartões de produto
  initProductCards() {
    const productCards = document.querySelectorAll('[data-product-card]:not([data-product-card-init])');
    productCards.forEach((card) => {
      card.setAttribute('data-product-card-init', '');
    });
  }



  initProductGallery() {
    const productSections = document.querySelectorAll('.main-product');
    if (!productSections.length) return;

    productSections.forEach((section) => {
      const gallery = section.querySelector('[data-product-gallery]');
      if (!gallery) return;

      const items = Array.from(gallery.querySelectorAll('.main-product__gallery-item'));
      const thumbnails = Array.from(section.querySelectorAll('[data-gallery-thumb]'));
      if (!items.length) return;

      let currentIndex = 0;

      const setActiveItem = (index) => {
        const numIndex = parseInt(index, 10);
        if (isNaN(numIndex) || numIndex < 0 || numIndex >= items.length) return;
        currentIndex = numIndex;

        items.forEach((item, i) => {
          const isActive = i === currentIndex;
          item.classList.toggle('is-active', isActive);
        });

        thumbnails.forEach((thumb, i) => {
          const isActive = i === currentIndex;
          thumb.classList.toggle('is-active', isActive);
          if (isActive && typeof thumb.scrollIntoView === 'function') {
            try {
              thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            } catch (e) {}
          }
        });
      };

      gallery._setActiveItem = setActiveItem;

      thumbnails.forEach((thumb) => {
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          const idx = thumb.dataset.galleryThumb;
          if (idx !== undefined) setActiveItem(idx);
        });
      });

      // Zoom na imagem principal da página de produto
      items.forEach((item) => {
        const img = item.querySelector('.main-product__image');
        if (!img) return;

        item.addEventListener('mouseenter', () => {
          img.style.transition = 'transform 0.15s ease-out';
          img.style.transform = 'scale(1.7)';
        });

        item.addEventListener('mousemove', (e) => {
          const rect = item.getBoundingClientRect();
          if (rect.width === 0 || rect.height === 0) return;
          const x = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
          const y = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));
          img.style.transformOrigin = `${x}% ${y}%`;
        });

        item.addEventListener('mouseleave', () => {
          img.style.transition = 'transform 0.25s ease-out';
          img.style.transform = 'scale(1)';
          img.style.transformOrigin = 'center center';
        });
      });

      let touchStartX = 0;
      let touchEndX = 0;

      gallery.addEventListener(
        'touchstart',
        (e) => {
          touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true }
      );

      gallery.addEventListener(
        'touchend',
        (e) => {
          touchEndX = e.changedTouches[0].screenX;
          const diffX = touchStartX - touchEndX;

          if (Math.abs(diffX) > 40) {
            if (diffX > 0) {
              setActiveItem((currentIndex + 1) % items.length);
            } else {
              setActiveItem((currentIndex - 1 + items.length) % items.length);
            }
          }
        },
        { passive: true }
      );
    });
  }

  initCartDrawer() {
    this.cartDrawer = document.querySelector('[data-cart-drawer]');
    if (!this.cartDrawer) return;

    this.cartDrawerBody = this.cartDrawer.querySelector('[data-cart-drawer-body]');
    this.cartDrawerFooter = this.cartDrawer.querySelector('[data-cart-drawer-footer]');
    this.cartDrawerSubtotal = this.cartDrawer.querySelector('[data-cart-drawer-subtotal]');

    const toggles = document.querySelectorAll('[data-cart-toggle]');
    toggles.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        this.openCartDrawer();
      });
    });

    const closeBtn = this.cartDrawer.querySelector('[data-cart-drawer-close]');
    if (closeBtn) closeBtn.addEventListener('click', () => this.closeCartDrawer());

    const overlay = this.cartDrawer.querySelector('[data-cart-drawer-overlay]');
    if (overlay) overlay.addEventListener('click', () => this.closeCartDrawer());

    this.cartDrawer.addEventListener(
      'click',
      (e) => {
        const link = e.target.closest('[data-cart-checkout]');
        if (!link || !this.cartDrawer.contains(link)) return;
        if (link.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          return;
        }
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        const href =
          link.getAttribute('href') ||
          link.dataset.checkoutUrl ||
          (window.routes && window.routes.checkout_url) ||
          '/checkout';
        if (!href || href === '#') {
          e.preventDefault();
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        this.handleCheckoutClick(link);
      },
      true
    );

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeCartDrawer();
    });
  }

  initCartOnlyDrawer() {
    const cartPath = (window.routes && window.routes.cart_url) || '/cart';

    let cartPathname = '/cart';
    try {
      cartPathname = new URL(cartPath, window.location.origin).pathname;
    } catch (e) {}

    if (window.location.pathname === cartPathname) {
      const redirectUrl = new URL(window.location.href);
      redirectUrl.pathname = '/';
      redirectUrl.searchParams.set('open_cart', '1');
      window.location.replace(redirectUrl.toString());
      return;
    }

    const params = new URLSearchParams(window.location.search);
    if (params.get('open_cart') === '1') {
      params.delete('open_cart');
      const query = params.toString();
      const nextUrl = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;
      window.history.replaceState({}, '', nextUrl);
      this.openCartDrawer();
      this.refreshCartUI();
    }

    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href]');
      if (!link || link.hasAttribute('data-cart-checkout')) return;
      if (link.target === '_blank') return;

      let linkUrl;
      try {
        linkUrl = new URL(link.href, window.location.origin);
      } catch (err) {
        return;
      }

      if (linkUrl.pathname !== cartPathname) return;
      if (!this.cartDrawer) return;

      e.preventDefault();
      this.openCartDrawer();
      this.refreshCartUI();
    });
  }

  initMainCartSteppers() {
    const buttons = document.querySelectorAll('[data-main-cart-qty-step]');
    if (!buttons.length) return;

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const delta = parseInt(btn.dataset.mainCartQtyStep, 10) || 0;
        const id = btn.dataset.input;
        if (!id) return;

        const input = document.getElementById(id);
        if (!input) return;

        const current = Math.max(0, parseInt(input.value, 10) || 0);
        const next = Math.max(0, current + delta);
        input.value = String(next);
      });
    });
  }

  initMainProduct() {
    const productSections = document.querySelectorAll('.main-product');
    if (!productSections.length) return;

    productSections.forEach((section) => {
      const variantsEl = section.querySelector('[data-product-variants]') || document.querySelector('[data-product-variants]');
      const variantMediaMapEl = section.querySelector('[data-product-variant-media-map]') || document.querySelector('[data-product-variant-media-map]');
      const form = section.querySelector('[data-product-form]');
      if (!variantsEl || !form) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsEl.textContent || '[]');
      } catch (e) {
        variants = [];
      }

      let variantMediaMap = {};
      if (variantMediaMapEl) {
        try {
          variantMediaMap = JSON.parse(variantMediaMapEl.textContent || '{}');
        } catch (e) {}
      }

      const idInput = form.querySelector('[data-variant-id]');
      const qtyInput = form.querySelector('[data-product-qty]');
      const addButton = form.querySelector('[data-add-to-cart]');
      const msgEl = section.querySelector('[data-product-message]');
      const priceRegular = section.querySelector('[data-product-price-regular]');
      const priceCompare = section.querySelector('[data-product-price-compare]');
      const installmentsEl = section.querySelector('[data-product-installments]');
      const stickyBar = section.querySelector('[data-sticky-atc-bar]');
      const stickyTrigger = section.querySelector('[data-sticky-atc-trigger]');
      const stickyPrice = section.querySelector('[data-sticky-price]');
      const stickyImage = section.querySelector('.sticky-atc-bar__image');
      const installmentCount = 6;

      if (stickyBar) {
        stickyBar.removeAttribute('hidden');
        stickyBar.hidden = false;

        const targetBtn = addButton || form.querySelector('button[type="submit"]');

        const checkSticky = () => {
          if (targetBtn) {
            const rect = targetBtn.getBoundingClientRect();
            if (rect.bottom < 0) {
              stickyBar.classList.add('sticky-atc-bar--visible');
            } else {
              stickyBar.classList.remove('sticky-atc-bar--visible');
            }
          } else {
            if (window.scrollY > 300) {
              stickyBar.classList.add('sticky-atc-bar--visible');
            } else {
              stickyBar.classList.remove('sticky-atc-bar--visible');
            }
          }
        };

        window.addEventListener('scroll', checkSticky, { passive: true });
        window.addEventListener('resize', checkSticky, { passive: true });
        setTimeout(checkSticky, 50);
        checkSticky();

        if (stickyTrigger) {
          const handleStickyClick = async (e) => {
            e.preventDefault();
            e.stopPropagation();

            const v = findVariant();
            if (!v || !v.available) {
              if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
              setMessage('Por favor, selecione uma opção disponível.', 'error');
              return;
            }

            const qty = Math.max(1, parseInt(qtyInput?.value || '1', 10) || 1);

            stickyTrigger.disabled = true;
            stickyTrigger.textContent = 'Adicionando...';
            if (addButton) {
              addButton.disabled = true;
              addButton.textContent = 'Adicionando...';
            }

            try {
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: v.id, quantity: qty })
              });

              if (!response.ok) throw new Error('Erro ao adicionar produto');

              await this.refreshCartUI();
              this.openCartDrawer();

              stickyTrigger.textContent = 'Adicionado!';
              if (addButton) addButton.textContent = 'Adicionado!';

              setTimeout(() => {
                stickyTrigger.textContent = v.available ? 'Adicionar ao carrinho' : 'Esgotado';
                stickyTrigger.disabled = !v.available;
                if (addButton) {
                  addButton.textContent = v.available
                    ? ((window.variantStrings && window.variantStrings.addToCart) || 'Adicionar ao carrinho')
                    : 'Esgotado';
                  addButton.disabled = !v.available;
                }
              }, 1500);
            } catch (err) {
              console.error('Erro ao adicionar via barra fixa:', err);
              setMessage('Não foi possível adicionar ao carrinho. Tente novamente.', 'error');
              stickyTrigger.disabled = !v.available;
              stickyTrigger.textContent = v.available ? 'Adicionar ao carrinho' : 'Esgotado';
              if (addButton) {
                addButton.disabled = !v.available;
                addButton.textContent = v.available ? 'Adicionar ao carrinho' : 'Esgotado';
              }
            }
          };

          stickyTrigger.addEventListener('click', handleStickyClick);
        }
      }

      const decodeHTMLEntities = (str) => {
        if (!str) return '';
        const txt = document.createElement('textarea');
        txt.innerHTML = String(str);
        return txt.value;
      };

      const getSelectedOptions = () => {
        const inputs = Array.from(form.querySelectorAll('[data-variant-option]'));
        if (!inputs.length) return [];

        const firstVariant = variants[0];
        let expectedCount = 0;
        if (firstVariant) {
          if (Array.isArray(firstVariant.options)) {
            expectedCount = firstVariant.options.length;
          } else {
            expectedCount = [firstVariant.option1, firstVariant.option2, firstVariant.option3].filter(
              (o) => o !== null && o !== undefined
            ).length;
          }
        }

        if (expectedCount === 0) return [];

        const values = new Array(expectedCount).fill('');

        inputs.forEach((el) => {
          const idx = parseInt(el.dataset.optionIndex, 10);
          if (isNaN(idx) || idx < 0 || idx >= expectedCount) return;

          if (el.tagName === 'SELECT') {
            values[idx] = String(el.value || '').trim();
          } else if (el.type === 'radio' && el.checked) {
            values[idx] = String(el.value || '').trim();
          }
        });

        return values;
      };

      const findVariant = () => {
        if (!variants || !variants.length) return null;

        if (variants.length === 1 && (variants[0].title === 'Default Title' || !variants[0].options || variants[0].options.length === 0)) {
          return variants[0];
        }

        const selected = getSelectedOptions();

        if (!selected.length) {
          const currentId = parseInt(idInput?.value, 10);
          if (currentId) {
            const matchById = variants.find((v) => v.id === currentId);
            if (matchById) return matchById;
          }
          return variants[0] || null;
        }

        if (selected.some((s) => !s)) {
          return null;
        }

        const matched = variants.find((v) => {
          const variantOptions = Array.isArray(v.options)
            ? v.options
            : [v.option1, v.option2, v.option3].filter((o) => o !== null && o !== undefined);

          return selected.every((selVal, idx) => {
            if (!selVal) return false;
            const vOpt = variantOptions[idx] !== undefined ? variantOptions[idx] : v[`option${idx + 1}`];
            if (vOpt === null || vOpt === undefined) return false;

            const cleanVOpt = decodeHTMLEntities(vOpt).trim().toLowerCase();
            const cleanSelVal = decodeHTMLEntities(selVal).trim().toLowerCase();
            return cleanVOpt === cleanSelVal;
          });
        });

        return matched || null;
      };

      const setMessage = (text, type = 'info') => {
        if (!msgEl) return;
        if (!text) {
          msgEl.hidden = true;
          msgEl.textContent = '';
          msgEl.className = 'main-product__message';
          return;
        }
        msgEl.hidden = false;
        msgEl.textContent = text;
        msgEl.className = `main-product__message main-product__message--${type}`;
      };

      const updateUIFromVariant = (variant) => {
        if (!variant) {
          if (idInput) idInput.value = '';
          setMessage('Variação indisponível.', 'error');
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = (window.variantStrings && window.variantStrings.unavailable) || 'Indisponível';
          }
          if (stickyTrigger) {
            stickyTrigger.disabled = true;
            stickyTrigger.textContent = 'Indisponível';
          }
          return;
        }

        if (idInput) idInput.value = variant.id;

        if (priceRegular) priceRegular.textContent = this.formatMoney(variant.price);
        if (stickyPrice) stickyPrice.textContent = this.formatMoney(variant.price);

        if (priceCompare) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceCompare.textContent = this.formatMoney(variant.compare_at_price);
            priceCompare.style.display = '';
          } else {
            priceCompare.textContent = '';
            priceCompare.style.display = 'none';
          }
        }

        if (installmentsEl) {
          if (variant.price > 0) {
            const installmentValue = Math.floor(variant.price / installmentCount);
            installmentsEl.innerHTML = `<span>ou <strong>${installmentCount}x</strong> de <strong>${this.formatMoney(installmentValue)}</strong> sem juros</span>`;
          } else {
            installmentsEl.innerHTML = `<span>ou <strong>${installmentCount}x</strong> sem juros</span>`;
          }
        }

        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available
            ? ((window.variantStrings && window.variantStrings.addToCart) || 'Adicionar ao carrinho')
            : ((window.variantStrings && window.variantStrings.soldOut) || 'Esgotado');
        }

        if (stickyTrigger) {
          stickyTrigger.disabled = !variant.available;
          stickyTrigger.textContent = variant.available ? 'Adicionar ao carrinho' : 'Esgotado';
        }

        if (variant.id && window.history && window.history.replaceState) {
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', newUrl.toString());
        }

        // Sincronizar imagem da variante na galeria principal
        const gallery = section.querySelector('[data-product-gallery]');
        const mediaData = variantMediaMap[variant.id] || {};
        const mediaId = mediaData.featured_media_id || mediaData.featured_image_id || mediaData.image_id || variant.featured_media?.id || variant.featured_image?.id || variant.image_id;
        const imageSrc = mediaData.image_src || variant.featured_image?.src || variant.featured_media?.preview_image?.src;

        if (imageSrc && stickyImage) {
          stickyImage.src = imageSrc;
        }

        if (gallery && typeof gallery._setActiveItem === 'function') {
          let targetIndex = -1;

          if (mediaId) {
            const itemWithId = gallery.querySelector(`[data-media-id="${mediaId}"]`);
            if (itemWithId && itemWithId.dataset.galleryIndex !== undefined) {
              targetIndex = parseInt(itemWithId.dataset.galleryIndex, 10);
            }
          }

          if (targetIndex < 0 && imageSrc) {
            const variantSrcClean = String(imageSrc).split('?')[0].split('/').pop().toLowerCase();
            const items = Array.from(gallery.querySelectorAll('.main-product__gallery-item'));
            targetIndex = items.findIndex((item) => {
              const img = item.querySelector('img');
              if (!img) return false;
              const imgSrcClean = (img.src || img.getAttribute('srcset') || '').split('?')[0].split('/').pop().toLowerCase();
              return imgSrcClean && variantSrcClean && (imgSrcClean.includes(variantSrcClean) || variantSrcClean.includes(imgSrcClean));
            });
          }

          if (targetIndex < 0) {
            const selectedOptions = getSelectedOptions();
            for (const optVal of selectedOptions) {
              if (!optVal) continue;
              const cleanOpt = String(optVal).toLowerCase().trim();
              if (!cleanOpt) continue;

              const items = Array.from(gallery.querySelectorAll('.main-product__gallery-item'));
              const foundIdx = items.findIndex((item) => {
                const img = item.querySelector('img');
                const alt = String(img?.alt || '').toLowerCase().trim();
                const src = String(img?.src || '').toLowerCase();
                return (alt && alt.includes(cleanOpt)) || (src && src.includes(cleanOpt));
              });

              if (foundIdx >= 0) {
                targetIndex = foundIdx;
                break;
              }
            }
          }

          if (targetIndex >= 0) {
            gallery._setActiveItem(targetIndex);
          }
        }

        setMessage('', 'info');
      };

      const onOptionChange = () => {
        const v = findVariant();
        updateUIFromVariant(v);
        section.querySelectorAll('[data-cart-shipping-product]').forEach((el) => {
          this.clearCartShippingResults(el);
        });
      };

      form.addEventListener('change', onOptionChange);
      form.addEventListener('input', onOptionChange);
      form.addEventListener('click', (e) => {
        if (e.target.closest('.main-product__pill') || e.target.closest('input[type="radio"]') || e.target.closest('[data-variant-option]')) {
          setTimeout(onOptionChange, 10);
        }
      });

      const optionInputs = form.querySelectorAll('[data-variant-option]');
      optionInputs.forEach((el) => {
        el.addEventListener('change', onOptionChange);
        el.addEventListener('input', onOptionChange);
      });

      if (qtyInput) {
        qtyInput.addEventListener('change', () => {
          section.querySelectorAll('[data-cart-shipping-product]').forEach((el) => {
            this.clearCartShippingResults(el);
          });
        });
      }

      onOptionChange();

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const v = findVariant();
        if (!v) {
          setMessage('Por favor, selecione as opções de cor e tamanho do produto.', 'error');
          updateUIFromVariant(null);
          return;
        }

        if (!v.available) {
          setMessage('A variação selecionada está esgotada.', 'error');
          updateUIFromVariant(v);
          return;
        }

        const qty = Math.max(1, parseInt(qtyInput?.value || '1', 10) || 1);
        const prevText = addButton ? addButton.textContent : '';
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'Adicionando...';
        }
        if (stickyTrigger) {
          stickyTrigger.disabled = true;
          stickyTrigger.textContent = 'Adicionando...';
        }
        setMessage('', 'info');

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: v.id, quantity: qty })
          });

          if (!response.ok) throw new Error('Erro ao adicionar produto');

          await this.refreshCartUI();
          this.openCartDrawer();
          if (addButton) {
            addButton.textContent = 'Adicionado!';
            setTimeout(() => {
              addButton.textContent = prevText || ((window.variantStrings && window.variantStrings.addToCart) || 'Adicionar ao carrinho');
              addButton.disabled = !v.available;
            }, 1200);
          }
          if (stickyTrigger) {
            stickyTrigger.textContent = 'Adicionado!';
            setTimeout(() => {
              stickyTrigger.textContent = v.available ? 'Adicionar ao carrinho' : 'Esgotado';
              stickyTrigger.disabled = !v.available;
            }, 1200);
          }
        } catch (error) {
          console.error('Erro:', error);
          setMessage('Não foi possível adicionar ao carrinho. Tente novamente.', 'error');
          if (addButton) {
            addButton.textContent = prevText;
            addButton.disabled = !v.available;
          }
          if (stickyTrigger) {
            stickyTrigger.textContent = v.available ? 'Adicionar ao carrinho' : 'Esgotado';
            stickyTrigger.disabled = !v.available;
          }
        }
      });
    });
  }

  openCartDrawer() {
    if (!this.cartDrawer) return;
    this.cartDrawer.hidden = false;
    this.cartDrawer.classList.add('cart-drawer--open');
    document.documentElement.classList.add('cart-drawer-open');
    this.refreshCartUI();
  }

  closeCartDrawer() {
    if (!this.cartDrawer) return;
    this.cartDrawer.classList.remove('cart-drawer--open');
    document.documentElement.classList.remove('cart-drawer-open');
    setTimeout(() => {
      if (!this.cartDrawer.classList.contains('cart-drawer--open')) {
        this.cartDrawer.hidden = true;
      }
    }, 200);
  }

  formatMoney(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
    } catch (e) {}
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return `R$ ${value}`;
  }

  async refreshCartUI() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      const cartCount = document.querySelector('[data-cart-count]');
      if (cartCount) cartCount.textContent = cart.item_count;

      this.updateCartExtras(cart);

      document.querySelectorAll('[data-cart-shipping-drawer]').forEach((el) => {
        el.hidden = cart.item_count === 0;
      });

      if (cart.item_count > 0) {
        this.recalculateCartShipping();
      } else {
        this.clearCartShippingResults();
        this.saveSelectedShippingRate(null);
        this.updateCartDrawerShippingSummary(cart);
      }

      if (this.cartDrawerBody) {
        if (cart.item_count === 0) {
          this.cartDrawerBody.innerHTML = `
            <div class="cart-drawer__empty">
              <p>Seu carrinho está vazio.</p>
              <a class="button button--secondary" href="/collections/all">Continuar comprando</a>
            </div>
          `;
          if (this.cartDrawerFooter) this.cartDrawerFooter.hidden = true;
        } else {
          const itemsHtml = cart.items.map((item) => {
            const img = item.image ? `<img class="cart-drawer__item-image" src="${item.image}" alt="${(item.product_title || '').replace(/"/g,'&quot;')}" loading="lazy">` : '';
            const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer__item-variant">${item.variant_title}</div>` : '';

            const priceHtml = (item.original_line_price && item.original_line_price > item.final_line_price)
              ? `<div class="cart-drawer__item-price"><span class="cart-drawer__price-discounted">${this.formatMoney(item.final_line_price)}</span> <s class="cart-drawer__price-original">${this.formatMoney(item.original_line_price)}</s></div>`
              : `<div class="cart-drawer__item-price">${this.formatMoney(item.final_line_price)}</div>`;

            const qtyHtml = `
              <div class="cart-drawer__qty-stepper" aria-label="Quantidade">
                <button class="cart-drawer__qty-btn" type="button" data-cart-qty-step="-1" data-line="${item.key}" aria-label="Diminuir quantidade">−</button>
                <input class="cart-drawer__qty" type="number" min="0" step="1" value="${item.quantity}" inputmode="numeric" data-cart-qty data-line="${item.key}" aria-label="Quantidade">
                <button class="cart-drawer__qty-btn" type="button" data-cart-qty-step="1" data-line="${item.key}" aria-label="Aumentar quantidade">+</button>
              </div>
              <button class="cart-drawer__remove" type="button" data-cart-remove data-line="${item.key}">Remover</button>
            `;

            return `
              <div class="cart-drawer__item" data-cart-key="${item.key}">
                <a class="cart-drawer__item-media" href="${item.url}">${img}</a>
                <div class="cart-drawer__item-info">
                  <a class="cart-drawer__item-title" href="${item.url}">${item.product_title}</a>
                  ${variant}
                  ${priceHtml}
                  <div class="cart-drawer__item-actions">
                    ${qtyHtml}
                  </div>
                </div>
              </div>
            `;
          }).join('');

          this.cartDrawerBody.innerHTML = `<div class="cart-drawer__items">${itemsHtml}</div>`;
          if (this.cartDrawerSubtotal) this.cartDrawerSubtotal.textContent = this.formatMoney(cart.total_price);
          
          const discountRow = this.cartDrawer?.querySelector('[data-cart-drawer-discount]');
          if (discountRow) {
            discountRow.hidden = true;
            discountRow.style.display = 'none';
          }

          if (this.cartDrawerFooter) this.cartDrawerFooter.hidden = false;
          this.updateCartDrawerShippingSummary(cart);

          const checkoutBtn = this.cartDrawer?.querySelector('[data-cart-checkout]');
          if (checkoutBtn) {
            const disabled = cart.item_count === 0;
            checkoutBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
            checkoutBtn.classList.toggle('cart-drawer__checkout--disabled', disabled);
          }

          // bind qty/remove
          this.cartDrawerBody.querySelectorAll('[data-cart-remove]').forEach((btn) => {
            btn.addEventListener('click', async () => {
              const key = btn.dataset.line;
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: 0 })
              });
              await this.refreshCartUI();
            });
          });

          this.cartDrawerBody.querySelectorAll('[data-cart-qty]').forEach((input) => {
            input.addEventListener('change', async () => {
              const key = input.dataset.line;
              const qty = Math.max(0, parseInt(input.value, 10) || 0);
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: qty })
              });
              await this.refreshCartUI();
            });
          });

          this.cartDrawerBody.querySelectorAll('[data-cart-qty-step]').forEach((btn) => {
            btn.addEventListener('click', async () => {
              const key = btn.dataset.line;
              const delta = parseInt(btn.dataset.cartQtyStep, 10) || 0;
              const input = this.cartDrawerBody.querySelector(`[data-cart-qty][data-line="${key}"]`);
              const current = Math.max(0, parseInt(input?.value, 10) || 0);
              const next = Math.max(0, current + delta);
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: next })
              });
              await this.refreshCartUI();
            });
          });
        }
      }
    } catch (error) {
      console.error('Erro ao atualizar carrinho:', error);
    }
  }

  updateCartExtras(cart) {
    document.querySelectorAll('[data-cart-upsell]').forEach((el) => {
      el.hidden = cart.item_count === 0;

      const upsellProductId = parseInt(el.dataset.cartUpsellProductId, 10);
      if (!upsellProductId) return;

      const inCart = cart.items.some((item) => item.product_id === upsellProductId);
      if (inCart) el.hidden = true;
    });

    this.updateQueimaFitnessPromo(cart);
  }

  updateQueimaFitnessPromo(cart) {
    const promoBanner = this.cartDrawer?.querySelector('[data-cart-promo-banner]');
    if (!promoBanner) return;

    if (!cart || cart.item_count === 0) {
      promoBanner.hidden = true;
      return;
    }

    // Conta itens elegíveis para a promoção Compre 2 Leve 3 (Apenas Vestuário Fitness, excluindo Camisetas e Camisas)
    const fitnessItems = (cart.items || []).filter((item) => {
      const type = (item.product_type || '').toLowerCase();
      const title = (item.title || '').toLowerCase();
      if (type.includes('camiseta') || type.includes('camisa') || title.includes('camiseta') || title.includes('camisa')) {
        return false;
      }
      return type === 'vestuário' || type === 'vestuario';
    });

    const totalQty = fitnessItems.reduce((acc, item) => acc + (item.quantity || 0), 0);
    const promoText = promoBanner.querySelector('[data-cart-promo-text]');
    const progressBar = promoBanner.querySelector('[data-cart-promo-progress]');
    const promoIcon = promoBanner.querySelector('[data-cart-promo-icon]');

    promoBanner.hidden = false;

    if (totalQty === 0) {
      if (promoIcon) promoIcon.textContent = '🔥';
      if (promoText) {
        promoText.innerHTML = `<strong>Esquenta Black:</strong> Compre 2 e <strong>Leve 3</strong>! <a href="/collections/queima-fitness" style="text-decoration:underline; font-weight:700;">Ver peças</a>`;
      }
      if (progressBar) progressBar.style.width = '0%';
    } else {
      const remainder = totalQty % 3;
      const completedSets = Math.floor(totalQty / 3);

      if (remainder === 1) {
        if (promoIcon) promoIcon.textContent = '🔥';
        if (promoText) {
          promoText.innerHTML = `<strong>Esquenta Black:</strong> Adicione mais <strong>2 peças</strong> para levar a 3ª GRÁTIS!`;
        }
        if (progressBar) progressBar.style.width = '33%';
      } else if (remainder === 2) {
        if (promoIcon) promoIcon.textContent = '⚡';
        if (promoText) {
          promoText.innerHTML = `<strong>Quase lá!</strong> Falta só <strong>1 peça</strong> para levar a 3ª GRÁTIS!`;
        }
        if (progressBar) progressBar.style.width = '66%';
      } else {
        if (promoIcon) promoIcon.textContent = '🎉';
        const freeCount = completedSets;
        if (promoText) {
          promoText.innerHTML = `<strong>Parabéns!</strong> Promoção Compre 2 Leve 3 ativada (${freeCount} peça${freeCount > 1 ? 's' : ''} grátis no checkout)!`;
        }
        if (progressBar) progressBar.style.width = '100%';
      }
    }
  }

  // Calculadora de frete no carrinho (CEP → taxas Shopify / Melhor Envio)
  initCartShipping() {
    this.cartShippingStorageKey = 'mtor_cart_shipping_cep';
    this.cartShippingSelectionKey = 'mtor_cart_shipping_selection';

    document.addEventListener('click', (e) => {
      const rateBtn = e.target.closest('[data-cart-shipping-rate]');
      if (!rateBtn) return;

      const root = rateBtn.closest('[data-cart-shipping]');
      if (!root || !Array.isArray(root._shippingRates)) return;

      const index = parseInt(rateBtn.dataset.rateIndex, 10);
      const rate = root._shippingRates[index];
      if (!rate) return;

      e.preventDefault();
      this.selectCartShippingRate(root, rate, index);
    });

    document.querySelectorAll('[data-cart-shipping]').forEach((root) => {
      if (root.dataset.cartShippingInit) return;
      root.dataset.cartShippingInit = 'true';

      const form = root.querySelector('[data-cart-shipping-form]');
      const cepInput = root.querySelector('[data-cart-shipping-cep]');
      if (!form || !cepInput) return;

      cepInput.addEventListener('input', () => {
        cepInput.value = this.formatCep(cepInput.value);
      });

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        await this.calculateCartShipping(root);
      });

      const savedCep = this.getSavedCartShippingCep();
      if (savedCep) {
        cepInput.value = this.formatCep(savedCep);
      }
    });

    document.querySelectorAll('[data-cart-shipping-drawer]').forEach((el) => {
      if (!el.hidden) {
        const cepInput = el.querySelector('[data-cart-shipping-cep]');
        const savedCep = this.getSavedCartShippingCep();
        if (cepInput && savedCep && !cepInput.value) {
          cepInput.value = this.formatCep(savedCep);
        }
      }
    });
  }

  formatCep(value) {
    const digits = String(value || '').replace(/\D/g, '').slice(0, 8);
    if (digits.length <= 5) return digits;
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  }

  getSavedCartShippingCep() {
    try {
      return localStorage.getItem(this.cartShippingStorageKey) || '';
    } catch (e) {
      return '';
    }
  }

  saveCartShippingCep(cep) {
    try {
      localStorage.setItem(this.cartShippingStorageKey, cep);
    } catch (e) {}
  }

  getSavedCartShippingAddress() {
    if (this.lastShippingAddress && this.lastShippingAddress.cep) {
      return this.lastShippingAddress;
    }
    try {
      const raw = localStorage.getItem('mtor_cart_shipping_address');
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && parsed.cep) {
          this.lastShippingAddress = parsed;
          return parsed;
        }
      }
    } catch (e) {}

    const savedCep = this.getSavedCartShippingCep();
    if (savedCep && savedCep.length === 8) {
      return { cep: savedCep, uf: '', localidade: '' };
    }
    return null;
  }

  saveCartShippingAddress(address) {
    if (!address || !address.cep) return;
    this.lastShippingAddress = address;
    try {
      localStorage.setItem('mtor_cart_shipping_address', JSON.stringify(address));
    } catch (e) {}
  }

  getCartShippingExtraDays(root) {
    const value = parseInt(root?.dataset?.extraDays, 10);
    return Number.isFinite(value) ? Math.max(0, value) : 2;
  }

  setCartShippingStatus(root, message, type) {
    const status = root.querySelector('[data-cart-shipping-status]');
    if (!status) return;
    if (!message) {
      status.hidden = true;
      status.textContent = '';
      status.classList.remove('cart-shipping__status--error', 'cart-shipping__status--success');
      return;
    }
    status.hidden = false;
    status.textContent = message;
    status.classList.toggle('cart-shipping__status--error', type === 'error');
    status.classList.toggle('cart-shipping__status--success', type === 'success');
  }

  clearCartShippingResults(root) {
    const targets = root ? [root] : document.querySelectorAll('[data-cart-shipping]');
    targets.forEach((el) => {
      const results = el.querySelector('[data-cart-shipping-results]');
      if (results) {
        results.hidden = true;
        results.innerHTML = '';
      }
      el.classList.remove('cart-shipping--has-results');
      delete el._shippingRates;
      this.setCartShippingStatus(el, '', '');
    });
  }

  async recalculateCartShipping() {
    const savedCep = this.getSavedCartShippingCep();
    if (!savedCep || savedCep.length !== 8) return;

    const calculators = document.querySelectorAll('[data-cart-shipping]:not([data-cart-shipping-product])');
    await Promise.all(
      Array.from(calculators).map(async (root) => {
        const cepInput = root.querySelector('[data-cart-shipping-cep]');
        if (cepInput && !cepInput.value) {
          cepInput.value = this.formatCep(savedCep);
        }
        await this.calculateCartShipping(root, { silent: true });
      })
    );
  }

  parseDeliveryDaysFromName(name) {
    const text = String(name || '').toLowerCase();
    const range = text.match(/(\d+)\s*(?:a|até|–|-)\s*(\d+)\s*dias/);
    if (range) {
      return { min: parseInt(range[1], 10), max: parseInt(range[2], 10) };
    }
    const single = text.match(/(\d+)\s*dias/);
    if (single) {
      const days = parseInt(single[1], 10);
      return { min: days, max: days };
    }
    return null;
  }

  formatDeliveryEstimate(name, extraDays) {
    const parsed = this.parseDeliveryDaysFromName(name);
    if (!parsed) return '';

    const min = parsed.min + extraDays;
    const max = parsed.max + extraDays;

    if (min === max) {
      return `Entrega em até ${min} dias úteis`;
    }
    return `Entrega em ${min} a ${max} dias úteis`;
  }

  formatDeliveryFromRate(rate, extraDays) {
    const deliveryDays = Array.isArray(rate.delivery_days)
      ? rate.delivery_days.map((day) => parseInt(day, 10)).filter((day) => Number.isFinite(day))
      : [];

    if (deliveryDays.length > 0) {
      const min = Math.min(...deliveryDays) + extraDays;
      const max = Math.max(...deliveryDays) + extraDays;
      if (min === max) return `Entrega em até ${min} dias úteis`;
      return `Entrega em ${min} a ${max} dias úteis`;
    }

    if (rate.delivery_date) {
      const date = new Date(rate.delivery_date);
      if (!Number.isNaN(date.getTime())) {
        return `Entrega prevista para ${date.toLocaleDateString('pt-BR')}`;
      }
    }

    return this.formatDeliveryEstimate(rate.name, extraDays);
  }

  async lookupCepAddress(cep) {
    const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
    if (!response.ok) throw new Error('CEP inválido');
    const data = await response.json();
    if (data.erro) throw new Error('CEP não encontrado');
    return data;
  }

  buildShippingAddressParams(address) {
    const params = new URLSearchParams({
      'shipping_address[zip]': address.cep,
      'shipping_address[country]': 'Brazil',
      'shipping_address[province]': address.uf,
      'shipping_address[city]': address.localidade,
      include_carrier_rates: 'true'
    });
    return params;
  }

  filterShippingRates(rates) {
    if (!Array.isArray(rates) || rates.length === 0) return [];

    const carrierRates = rates.filter((rate) => {
      if (rate.carrier_service_id) return true;
      if (rate.api_client_id) return true;
      if (rate.source && rate.source !== 'shopify') return true;
      const name = String(rate.name || '').toLowerCase();
      return !['padrão', 'padrao', 'standard', 'frete padrão', 'frete padrao'].includes(name);
    });

    return carrierRates.length > 0 ? carrierRates : rates;
  }

  hasCarrierShippingRates(rates) {
    return rates.some(
      (rate) =>
        rate.carrier_service_id ||
        rate.api_client_id ||
        (rate.source && rate.source !== 'shopify')
    );
  }

  async fetchCartShippingRates(address) {
    const params = this.buildShippingAddressParams(address);
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    };
    const query = params.toString();

    const prepareResponse = await fetch(`/cart/prepare_shipping_rates.json?${query}`, {
      method: 'POST',
      headers
    });

    if (!prepareResponse.ok && prepareResponse.status !== 202) {
      let data = {};
      try {
        data = await prepareResponse.json();
      } catch (e) {}
      throw new Error(data?.description || data?.message || 'Não foi possível iniciar o cálculo de frete.');
    }

    const pollAsyncRates = async (attempt = 0) => {
      if (attempt > 15) return [];

      const response = await fetch(`/cart/async_shipping_rates.json?${query}`, {
        method: 'GET',
        headers
      });

      const raw = await response.text();

      if (!response.ok) {
        let data = {};
        try {
          data = JSON.parse(raw);
        } catch (e) {}
        const errMsg = Array.isArray(data?.error) ? data.error[0] : data?.description || data?.message;
        throw new Error(errMsg || 'Não foi possível calcular o frete.');
      }

      if (!raw || raw.trim() === '' || raw.trim() === 'null') {
        await new Promise((resolve) => setTimeout(resolve, 500 + attempt * 250));
        return pollAsyncRates(attempt + 1);
      }

      let data;
      try {
        data = JSON.parse(raw);
      } catch (e) {
        await new Promise((resolve) => setTimeout(resolve, 500));
        return pollAsyncRates(attempt + 1);
      }

      const rates = Array.isArray(data?.shipping_rates) ? data.shipping_rates : [];
      if (rates.length === 0 && attempt < 15) {
        await new Promise((resolve) => setTimeout(resolve, 500 + attempt * 250));
        return pollAsyncRates(attempt + 1);
      }

      return rates;
    };

    let rates = this.filterShippingRates(await pollAsyncRates());

    if (rates.length === 0) {
      const fallbackResponse = await fetch(`/cart/shipping_rates.json?${query}`, { headers });
      const fallbackData = await fallbackResponse.json();
      if (!fallbackResponse.ok) {
        throw new Error(
          fallbackData?.description || fallbackData?.message || 'Não foi possível calcular o frete.'
        );
      }
      rates = this.filterShippingRates(
        Array.isArray(fallbackData.shipping_rates) ? fallbackData.shipping_rates : []
      );
    }

    return rates;
  }

  escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  getShippingRateKey(rate) {
    const code = String(rate?.code || '').trim();
    const name = String(rate?.name || '').trim();
    const price = String(rate?.price || '0');
    const carrierId = String(rate?.carrier_service_id || '');
    return [code, name, price, carrierId].join('::');
  }

  getSelectedShippingRate() {
    try {
      const raw = localStorage.getItem(this.cartShippingSelectionKey);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return parsed && parsed.key ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  saveSelectedShippingRate(selection) {
    if (!selection) {
      try {
        localStorage.removeItem(this.cartShippingSelectionKey);
      } catch (e) {}
      return;
    }

    try {
      localStorage.setItem(this.cartShippingSelectionKey, JSON.stringify(selection));
    } catch (e) {}
  }

  parseShippingRatePriceCents(price) {
    const normalized = String(price ?? '0').trim().replace(',', '.');
    const value = parseFloat(normalized);
    if (!Number.isFinite(value)) return 0;
    return Math.round(value * 100);
  }

  buildShippingSelection(rate, extraDays, isDrawer) {
    const priceCents = this.parseShippingRatePriceCents(rate.price);
    const priceLabel = priceCents === 0 ? 'Grátis' : this.formatMoney(priceCents);
    const deliveryRaw = this.formatDeliveryFromRate(rate, extraDays);
    const delivery =
      isDrawer && deliveryRaw
        ? deliveryRaw
            .replace(/^Entrega em até /, 'Até ')
            .replace(/^Entrega em /, '')
            .replace(/^Entrega prevista para /, 'Prev. ')
        : deliveryRaw;

    return {
      key: this.getShippingRateKey(rate),
      code: rate.code || '',
      name: rate.name || '',
      cleanName: this.formatShippingRateName(rate.name),
      priceCents,
      priceLabel,
      delivery
    };
  }

  async selectCartShippingRate(root, rate, index, options = {}) {
    const { silent = false } = options;
    const extraDays = this.getCartShippingExtraDays(root);
    const isDrawer = root.dataset.cartShippingContext === 'drawer';
    const selection = this.buildShippingSelection(rate, extraDays, isDrawer);

    root.querySelectorAll('[data-cart-shipping-rate]').forEach((btn) => {
      const isSelected = parseInt(btn.dataset.rateIndex, 10) === index;
      btn.classList.toggle('cart-shipping__rate--selected', isSelected);
      btn.setAttribute('aria-checked', isSelected ? 'true' : 'false');
    });

    this.saveSelectedShippingRate(selection);

    try {
      await this.persistShippingSelectionToCart(selection);
    } catch (e) {
      if (!silent) {
        this.setCartShippingStatus(root, 'Não foi possível salvar o frete escolhido. Tente novamente.', 'error');
      }
      return;
    }

    if (!silent) {
      this.setCartShippingStatus(
        root,
        `Frete selecionado: ${selection.cleanName} (${selection.priceLabel})`,
        'success'
      );
    }

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      this.updateCartDrawerShippingSummary(cart);
    } catch (e) {}
  }

  async persistShippingSelectionToCart(selection) {
    if (!selection) return;

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Frete escolhido': selection.cleanName || selection.name,
          'Valor do frete': selection.priceLabel,
          'Prazo estimado': selection.delivery || '',
          _frete_codigo: selection.code || '',
          _frete_preco_centavos: String(selection.priceCents)
        }
      })
    });

    if (!response.ok) {
      throw new Error('Falha ao salvar frete no carrinho.');
    }
  }

  updateCartDrawerShippingSummary(cart) {
    const shippingRow = document.querySelector('[data-cart-drawer-shipping]');
    const shippingValue = document.querySelector('[data-cart-drawer-shipping-value]');
    const totalRow = document.querySelector('[data-cart-drawer-total]');
    const totalValue = document.querySelector('[data-cart-drawer-total-value]');
    const selection = this.getSelectedShippingRate();

    if (!shippingRow || !shippingValue) return;

    if (!selection) {
      shippingRow.hidden = true;
      if (totalRow) totalRow.hidden = true;
      return;
    }

    shippingRow.hidden = false;
    shippingValue.textContent = `${selection.cleanName} · ${selection.priceLabel}`;

    if (totalRow && totalValue && cart) {
      totalRow.hidden = false;
      const effectiveTotal = typeof cart._effectiveSubtotal === 'number' ? cart._effectiveSubtotal : cart.total_price;
      totalValue.textContent = this.formatMoney(effectiveTotal + selection.priceCents);
    }
  }

  buildCheckoutUrl(href) {
    const url = new URL(href, window.location.origin);
    const address = this.getSavedCartShippingAddress();
    const selection = this.getSelectedShippingRate();

    if (address && address.cep) {
      const formattedCep = this.formatCep(address.cep);
      url.searchParams.set('checkout[shipping_address][zip]', formattedCep);
      if (address.localidade) {
        url.searchParams.set('checkout[shipping_address][city]', address.localidade);
      }
      if (address.uf) {
        url.searchParams.set('checkout[shipping_address][province]', address.uf);
        url.searchParams.set('checkout[shipping_address][province_code]', address.uf);
      }
      url.searchParams.set('checkout[shipping_address][country]', 'BR');
      url.searchParams.set('checkout[shipping_address][country_code]', 'BR');
    }

    if (selection) {
      const rateName = selection.cleanName || selection.name;
      if (rateName) {
        url.searchParams.set('checkout[shipping_rate][name]', rateName);
      }
    }

    return url.toString();
  }

  async handleCheckoutClick(link) {
    const href =
      link.getAttribute('href') ||
      link.dataset.checkoutUrl ||
      (window.routes && window.routes.checkout_url) ||
      '/checkout';

    const selection = this.getSelectedShippingRate();
    const address = this.getSavedCartShippingAddress();

    const drawerShipping = document.querySelector('[data-cart-shipping-drawer]:not([hidden])');
    const hasRates =
      drawerShipping &&
      drawerShipping.classList.contains('cart-shipping--has-results') &&
      Array.isArray(drawerShipping._shippingRates) &&
      drawerShipping._shippingRates.length > 0;

    if (hasRates && !selection) {
      this.setCartShippingStatus(
        drawerShipping,
        'Selecione uma opção de frete antes de finalizar a compra.',
        'error'
      );
      drawerShipping.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return;
    }

    if (selection) {
      try {
        await this.persistShippingSelectionToCart(selection);
      } catch (e) {
        if (drawerShipping) {
          this.setCartShippingStatus(drawerShipping, e.message || 'Erro ao salvar frete escolhido.', 'error');
          return;
        }
      }
    }

    if (address && address.cep) {
      try {
        await this.fetchCartShippingRates(address);
      } catch (e) {}
    }

    window.location.assign(this.buildCheckoutUrl(href));
  }

  formatShippingRateName(name) {
    let text = String(name || '').trim();
    text = text.replace(/^melhor\s*envio\s*[-–—:]\s*/i, '');
    text = text.replace(/\s*[-–—]\s*correios$/i, '');
    text = text.replace(/\s+/g, ' ').trim();
    return text || String(name || '').trim();
  }

  renderCartShippingRates(root, rates) {
    const results = root.querySelector('[data-cart-shipping-results]');
    if (!results) return;

    const extraDays = this.getCartShippingExtraDays(root);
    const isDrawer = root.dataset.cartShippingContext === 'drawer';
    const sorted = [...rates].sort(
      (a, b) => this.parseShippingRatePriceCents(a.price) - this.parseShippingRatePriceCents(b.price)
    );
    root._shippingRates = sorted;

    const savedKey = this.getSelectedShippingRate()?.key;
    let selectedIndex = savedKey ? sorted.findIndex((rate) => this.getShippingRateKey(rate) === savedKey) : 0;
    if (selectedIndex < 0) selectedIndex = 0;

    const itemsHtml = sorted
      .map((rate, index) => {
        const selection = this.buildShippingSelection(rate, extraDays, isDrawer);
        const isSelected = index === selectedIndex;
        const badge =
          index === 0
            ? `<span class="cart-shipping__badge">${isDrawer ? 'Menor preço' : 'Melhor preço'}</span>`
            : '';

        return `
          <li class="cart-shipping__rate-item">
            <button
              type="button"
              class="cart-shipping__rate${isSelected ? ' cart-shipping__rate--selected' : ''}${index === 0 ? ' cart-shipping__rate--best' : ''}"
              data-cart-shipping-rate
              data-rate-index="${index}"
              role="radio"
              aria-checked="${isSelected ? 'true' : 'false'}"
            >
              <span class="cart-shipping__rate-check" aria-hidden="true"></span>
              <span class="cart-shipping__rate-main">
                <span class="cart-shipping__rate-name">${this.escapeHtml(selection.cleanName)}${badge}</span>
                ${selection.delivery ? `<span class="cart-shipping__rate-delivery">${this.escapeHtml(selection.delivery)}</span>` : ''}
              </span>
              <span class="cart-shipping__rate-price">${this.escapeHtml(selection.priceLabel)}</span>
            </button>
          </li>
        `;
      })
      .join('');

    const ratesClass = isDrawer
      ? 'cart-shipping__rates cart-shipping__rates--drawer'
      : 'cart-shipping__rates';

    results.innerHTML = `<ul class="${ratesClass}" role="radiogroup" aria-label="Opções de frete">${itemsHtml}</ul>`;
    results.hidden = false;
    root.classList.toggle('cart-shipping--has-results', sorted.length > 0);

    if (sorted[selectedIndex]) {
      this.selectCartShippingRate(root, sorted[selectedIndex], selectedIndex, { silent: true });
    }
  }

  async ensureProductCartForShipping(root) {
    const section = root.closest('.main-product');
    if (!section) return;

    const form = section.querySelector('[data-product-form]');
    const variantId = parseInt(form?.querySelector('[data-variant-id]')?.value, 10);
    const qty = Math.max(1, parseInt(form?.querySelector('[data-product-qty]')?.value, 10) || 1);

    if (!variantId) {
      throw new Error('Selecione uma variação do produto.');
    }

    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    const line = cart.items.find((item) => item.variant_id === variantId);

    if (cart.item_count === 0) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      await this.refreshCartUI();
      return;
    }

    if (!line) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      await this.refreshCartUI();
      return;
    }

    if (line.quantity !== qty) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: qty })
      });
      await this.refreshCartUI();
    }
  }

  async calculateCartShipping(root, options = {}) {
    const { silent = false } = options;
    const cepInput = root.querySelector('[data-cart-shipping-cep]');
    const submitBtn = root.querySelector('[data-cart-shipping-submit]');
    if (!cepInput) return;

    const cep = cepInput.value.replace(/\D/g, '');
    if (cep.length !== 8) {
      if (!silent) this.setCartShippingStatus(root, 'Informe um CEP válido com 8 dígitos.', 'error');
      return;
    }

    const prevText = submitBtn?.textContent;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Calculando...';
    }
    if (!silent) this.setCartShippingStatus(root, 'Consultando transportadoras...', 'success');

    try {
      if (root.dataset.cartShippingContext === 'product' || root.hasAttribute('data-cart-shipping-product')) {
        await this.ensureProductCartForShipping(root);
      }

      const address = await this.lookupCepAddress(cep);
      const addrObj = {
        cep,
        uf: address.uf || '',
        localidade: address.localidade || ''
      };
      this.saveCartShippingAddress(addrObj);
      const rates = await this.fetchCartShippingRates(addrObj);

      if (rates.length === 0) {
        this.clearCartShippingResults(root);
        if (!silent) {
          this.setCartShippingStatus(
            root,
            'Nenhuma opção de frete encontrada para este CEP. Confira no checkout ou tente outro CEP.',
            'error'
          );
        }
        return;
      }

      this.saveCartShippingCep(cep);
      this.renderCartShippingRates(root, rates);
      if (!silent) {
        let statusMessage = `Frete para ${address.localidade} - ${address.uf}`;
        if (!this.hasCarrierShippingRates(rates)) {
          statusMessage +=
            '. Exibindo tarifa da loja. Confira no checkout se o Melhor Envio (CCS) estiver ativo.';
        }
        this.setCartShippingStatus(root, statusMessage, 'success');
      }
    } catch (error) {
      this.clearCartShippingResults(root);
      if (!silent) {
        this.setCartShippingStatus(root, error.message || 'Erro ao calcular frete. Tente novamente.', 'error');
      }
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = prevText || 'Calcular';
      }
    }
  }

  // Botão "Adicionar" da sugestão de produto no carrinho (upsell)
  initCartUpsell() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-cart-upsell-add]');
      if (!btn) return;

      e.preventDefault();
      const variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;

      const prevText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adicionando...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (!response.ok) throw new Error('Erro ao adicionar');

        await this.refreshCartUI();
        this.openCartDrawer();
        btn.textContent = 'Adicionado!';
        setTimeout(() => {
          btn.textContent = prevText;
          btn.disabled = false;
        }, 1200);
      } catch (error) {
        console.error('Erro ao adicionar sugestão:', error);
        btn.textContent = prevText;
        btn.disabled = false;
      }
    });
  }

  /** Barra de busca expansível no cabeçalho tipo “dropdown-header” (.dh-header). */
  initDhSearchBar() {
    const panel = document.querySelector('[data-dh-search-panel]');
    const toggle = document.querySelector('[data-dh-search-toggle]');
    if (!panel || !toggle) return;

    const closePanel = () => {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    };

    const openPanel = () => {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      const input = panel.querySelector('[data-dh-search-input]');
      if (input) {
        window.requestAnimationFrame(() => input.focus());
      }
    };

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (panel.hidden) openPanel();
      else closePanel();
    });

    const closeBtn = panel.querySelector('[data-dh-search-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closePanel();
      });
    }

    document.addEventListener(
      'click',
      (e) => {
        if (panel.hidden) return;
        if (toggle.contains(e.target) || panel.contains(e.target)) return;
        closePanel();
      },
      false
    );

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || panel.hidden) return;
      closePanel();
    });
  }

  /** Menu hambúrguer no cabeçalho tipo “dropdown-header” (.dh-header). */
  initDhMobileMenu() {
    const bind = (root) => {
      const menu = root.querySelector('[data-dh-mobile-menu]');
      const toggle = root.querySelector('[data-dh-menu-toggle]');
      if (!menu || !toggle || menu.dataset.dhMenuBound === 'true') return;
      menu.dataset.dhMenuBound = 'true';

      const closeButtons = menu.querySelectorAll('[data-dh-menu-close]');

      const closeMenu = () => {
        menu.hidden = true;
        menu.classList.remove('dh-mobile-menu--open');
        toggle.classList.remove('dh-menu-toggle--active');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('dh-mobile-menu-open');
      };

      const openMenu = () => {
        menu.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        toggle.classList.add('dh-menu-toggle--active');
        document.body.classList.add('dh-mobile-menu-open');
        window.requestAnimationFrame(() => {
          menu.classList.add('dh-mobile-menu--open');
          const closeBtn = menu.querySelector('.dh-mobile-menu__close');
          if (closeBtn) closeBtn.focus();
        });
      };

      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (menu.hidden) openMenu();
        else closeMenu();
      });

      closeButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          closeMenu();
        });
      });

      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => closeMenu());
      });

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || menu.hidden) return;
        closeMenu();
        toggle.focus();
      });
    };

    document.querySelectorAll('.dh-header').forEach(bind);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target;
      if (!section) return;
      section.querySelectorAll('.dh-header').forEach(bind);
    });
  }

  /** Recomendações Shopify (Section Rendering API) em related-products.liquid */
  initRelatedProductRecommendations() {
    const load = (wrap) => {
      const url = wrap.dataset.url;
      if (!url || wrap.dataset.loaded === 'true') return;
      if (wrap.querySelector('.related-products__grid')) {
        wrap.dataset.loaded = 'true';
        return;
      }
      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-related-recommendations]');
          if (!fresh) return;
          wrap.innerHTML = fresh.innerHTML;
          wrap.dataset.loaded = 'true';
        })
        .catch(() => {});
    };

    document.querySelectorAll('[data-related-recommendations]').forEach(load);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target;
      if (!section) return;
      section.querySelectorAll('[data-related-recommendations]').forEach(load);
    });
  }

  // Inicializar funcionalidade de pesquisa
  initSearch() {
    const searchToggle = document.querySelector('[data-search-toggle]');
    const searchForm = document.querySelector('.header__search-form');
    
    if (searchToggle && searchForm) {
      searchToggle.addEventListener('click', () => {
        searchForm.classList.toggle('header__search-form--active');
        
        if (searchForm.classList.contains('header__search-form--active')) {
          const searchInput = searchForm.querySelector('input[type="search"]');
          if (searchInput) {
            searchInput.focus();
          }
        }
      });
      
      // Fechar pesquisa ao clicar fora
      document.addEventListener('click', (e) => {
        if (!searchForm.contains(e.target) && !searchToggle.contains(e.target)) {
          searchForm.classList.remove('header__search-form--active');
        }
      });
    }
  }

  // Inicializar menu mobile
  initMobileMenu() {
    const menuToggle = document.querySelector('[data-menu-toggle]');
    const mobileMenu = document.querySelector('.header__mobile-menu');
    
    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', () => {
        mobileMenu.classList.toggle('header__mobile-menu--active');
        menuToggle.classList.toggle('header__menu-toggle--active');
        
        // Animar linhas do botão
        const lines = menuToggle.querySelectorAll('.header__menu-toggle-line');
        lines.forEach((line, index) => {
          if (mobileMenu.classList.contains('header__mobile-menu--active')) {
            if (index === 0) line.style.transform = 'rotate(45deg) translate(5px, 5px)';
            if (index === 1) line.style.opacity = '0';
            if (index === 2) line.style.transform = 'rotate(-45deg) translate(7px, -6px)';
          } else {
            line.style.transform = 'none';
            line.style.opacity = '1';
          }
        });
      });
    }
  }

  initCollectionPriceRange() {
    const ranges = document.querySelectorAll('[data-price-range]');
    if (!ranges.length) return;

    const formatBRL = (value) => {
      const n = Number(value || 0);
      return `R$ ${n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
    };

    ranges.forEach((wrap) => {
      const min = Number(wrap.dataset.min || 0);
      const max = Number(wrap.dataset.max || 1000);

      const minInput = wrap.querySelector('[data-price-range-min]');
      const maxInput = wrap.querySelector('[data-price-range-max]');
      const minHidden = wrap.querySelector('[data-price-range-min-hidden]');
      const maxHidden = wrap.querySelector('[data-price-range-max-hidden]');
      const minLabel = wrap.querySelector('[data-price-range-min-label]');
      const maxLabel = wrap.querySelector('[data-price-range-max-label]');

      if (!minInput || !maxInput || !minHidden || !maxHidden) return;

      const clamp = (v) => Math.min(max, Math.max(min, v));
      const toInt = (v) => clamp(parseInt(v, 10) || 0);

      const sync = () => {
        let vMin = toInt(minInput.value);
        let vMax = toInt(maxInput.value);
        if (vMin > vMax) [vMin, vMax] = [vMax, vMin];

        minInput.value = String(vMin);
        maxInput.value = String(vMax);

        // Shopify espera vazio quando "sem limite".
        minHidden.value = vMin <= min ? '' : String(vMin);
        maxHidden.value = vMax >= max ? '' : String(vMax);

        if (minLabel) minLabel.textContent = formatBRL(vMin);
        if (maxLabel) maxLabel.textContent = formatBRL(vMax);
      };

      minInput.addEventListener('input', sync);
      maxInput.addEventListener('input', sync);
      sync();
    });
  }

  initCollectionInfiniteScroll() {
    const root = document.querySelector('[data-collection-infinite]');
    if (!root) return;

    const grid = document.querySelector('[data-collection-grid]');
    const sentinel = root.querySelector('[data-collection-infinite-sentinel]');
    const loadingEl = root.querySelector('[data-collection-infinite-loading]');
    const endEl = root.querySelector('[data-collection-infinite-end]');
    const errorEl = root.querySelector('[data-collection-infinite-error]');

    let nextUrl = root.dataset.nextUrl || '';
    let isLoading = false;

    const setLoading = (state) => {
      isLoading = state;
      if (loadingEl) loadingEl.hidden = !state;
    };

    const showEnd = () => {
      if (sentinel) sentinel.remove();
      if (endEl) endEl.hidden = false;
      root.dataset.nextUrl = '';
      nextUrl = '';
    };

    const loadMore = async () => {
      if (!nextUrl || isLoading || !grid) return;

      setLoading(true);
      if (errorEl) errorEl.hidden = true;

      try {
        const response = await fetch(nextUrl, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('collection-page-fetch-failed');

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll('[data-collection-grid] .main-collection__item');
        const newInfinite = doc.querySelector('[data-collection-infinite]');

        newItems.forEach((item) => grid.appendChild(item));

        nextUrl = newInfinite?.dataset.nextUrl || '';
        root.dataset.nextUrl = nextUrl;

        this.initProductCards();

        if (!nextUrl) showEnd();
      } catch (error) {
        if (errorEl) errorEl.hidden = false;
      } finally {
        setLoading(false);
      }
    };

    if (!nextUrl) {
      showEnd();
      return;
    }

    if (!('IntersectionObserver' in window) || !sentinel) {
      const fallback = document.createElement('button');
      fallback.type = 'button';
      fallback.className = 'button button--secondary main-collection__infinite-fallback';
      fallback.textContent = 'Carregar mais produtos';
      fallback.addEventListener('click', loadMore);
      root.insertBefore(fallback, sentinel);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        loadMore();
      }
    }, { rootMargin: '240px 0px' });

    observer.observe(sentinel);
  }

  // Atualizar contador do carrinho
  async updateCartCount() {
    // Mantido por compatibilidade; preferir refreshCartUI().
    return this.refreshCartUI();
  }

  // Mostrar notificação
  showNotification(message, type = 'info') {
    // Remover notificações existentes
    const existingNotifications = document.querySelectorAll('.notification');
    existingNotifications.forEach(notification => notification.remove());
    
    // Criar nova notificação
    const notification = document.createElement('div');
    notification.className = `notification notification--${type}`;
    notification.innerHTML = `
      <div class="notification__content">
        <span class="notification__message">${message}</span>
        <button class="notification__close" aria-label="Fechar">&times;</button>
      </div>
    `;
    
    // Adicionar ao DOM
    document.body.appendChild(notification);
    
    // Mostrar notificação
    setTimeout(() => {
      notification.classList.add('notification--visible');
    }, 100);
    
    // Auto-remover após 5 segundos
    setTimeout(() => {
      notification.classList.remove('notification--visible');
      setTimeout(() => {
        if (notification.parentNode) {
          notification.remove();
        }
      }, 300);
    }, 5000);
    
    // Botão de fechar
    const closeButton = notification.querySelector('.notification__close');
    closeButton.addEventListener('click', () => {
      notification.classList.remove('notification--visible');
      setTimeout(() => {
        if (notification.parentNode) {
          notification.remove();
        }
      }, 300);
    });
  }

  // Utilitário para debounce
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Utilitário para throttle
  throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }
}

// Inicializar tema quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new Theme();
  });
} else {
  new Theme();
}

// Inicializar tema quando a página estiver totalmente carregada
window.addEventListener('load', () => {
  // Adicionar classe para indicar que a página foi carregada
  document.body.classList.add('page-loaded');
});

// Suporte para funcionalidades do Shopify
if (typeof Shopify !== 'undefined') {
  // Atualizar carrinho quando produtos forem adicionados
  document.addEventListener('cart:updated', () => {
    const theme = window.theme;
    if (theme && theme.updateCartCount) {
      theme.updateCartCount();
    }
  });
  
  // Suporte para pesquisa preditiva
  if (Shopify.theme.settings.predictive_search_enabled) {
    // Implementar pesquisa preditiva aqui
  }
}

// Suporte para funcionalidades de acessibilidade
document.addEventListener('keydown', (e) => {
  // Fechar menus ao pressionar Escape
  if (e.key === 'Escape') {
    const activeMenus = document.querySelectorAll('.header__mobile-menu--active, .header__search-form--active');
    activeMenus.forEach(menu => {
      menu.classList.remove('header__mobile-menu--active', 'header__search-form--active');
    });

    const dhMobileMenu = document.querySelector('[data-dh-mobile-menu]:not([hidden])');
    if (dhMobileMenu) {
      const toggle = document.querySelector('[data-dh-menu-toggle]');
      dhMobileMenu.hidden = true;
      dhMobileMenu.classList.remove('dh-mobile-menu--open');
      document.body.classList.remove('dh-mobile-menu-open');
      if (toggle) {
        toggle.classList.remove('dh-menu-toggle--active');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    }
    
    const activeMenuToggle = document.querySelector('.header__menu-toggle--active');
    if (activeMenuToggle) {
      activeMenuToggle.classList.remove('header__menu-toggle--active');
    }
  }
});

// Suporte para funcionalidades de performance
if ('IntersectionObserver' in window) {
  // Lazy loading para imagens
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.dataset.src;
        img.classList.remove('lazy');
        observer.unobserve(img);
      }
    });
  });
  
  document.querySelectorAll('img[data-src]').forEach(img => {
    imageObserver.observe(img);
  });
}
